import React from "react";
import ArrowLeft from "./arrowleft";
import ArrowRight from "./arrowright";

interface Props {
  optionsPanelData: server.dto.OptionsPanelDataV2

  // When going to the prev/next item, whether the 'hash' portion of the current URL should be included
  includeHash?: boolean
}

const OptionsPanelFooter = ({ optionsPanelData, includeHash }: Props) => {
  const [hash, setHash] = React.useState<string>(window.location.hash);

  const onHashChange = React.useCallback(() => setHash(window.location.hash), []);

  React.useEffect(() => {
    window.addEventListener("hashchange", onHashChange);
    return () => {
      window.removeEventListener("hashchange", onHashChange);
    };
  }, [onHashChange]);

  const prevUrl = includeHash && (optionsPanelData.previousUrl)
    ? `${optionsPanelData.previousUrl}${hash}`
    : optionsPanelData.previousUrl;

  const nextUrl = includeHash && (optionsPanelData.nextUrl)
    ? `${optionsPanelData.nextUrl}${hash}`
    : optionsPanelData.nextUrl;

  if (optionsPanelData.recordCount < 2) return undefined;

  return <div className="flex justify-space-between align-center">
    <ArrowLeft url={prevUrl} />
    <div>
      {optionsPanelData.currentPosition} / {optionsPanelData.recordCount}
    </div>
    <ArrowRight url={nextUrl} />
  </div>;
};

export default OptionsPanelFooter;
